import React from 'react';
import { motion } from 'framer-motion';
import { FiShield, FiClock, FiDollarSign, FiUsers, FiLayers } from 'react-icons/fi';

const reasons = [
  {
    title: "Keamanan Terjamin",
    desc: "Protokol keamanan ketat untuk setiap jenis pengiriman, didukung dengan asuransi untuk perlindungan maksimal aset Anda.",
    icon: FiShield
  },
  {
    title: "Ketepatan Waktu",
    desc: "Kami menghargai waktu Anda. Sistem penjadwalan kami dirancang khusus secara presisi untuk meminimalisir keterlambatan.",
    icon: FiClock
  },
  {
    title: "Transparansi Biaya",
    desc: "Harga kompetitif tanpa biaya tersembunyi. Kami memberikan solusi logistik yang paling efektif sesuai anggaran Anda.",
    icon: FiDollarSign
  },
  {
    title: "Tim Profesional",
    desc: "Dukungan operasional penuh dari tenaga ahli yang berpengalaman menangani berbagai kompleksitas logistik lapangan.",
    icon: FiUsers
  },
  {
    title: "Solusi Satu Pintu",
    desc: "Dari kurir instan hingga kontainer internasional, semua kebutuhan logistik Anda tersedia dan terkelola di satu platform.",
    icon: FiLayers
  }
];

const WhyUs = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-4 md:px-8">
        
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-brand-black">Mengapa Memilih Kami?</h2>
          <p className="text-gray-600 text-lg">Keunggulan yang menjadikan kami mitra terpercaya untuk pertumbuhan bisnis Anda.</p>
        </div>

        <div className="max-w-5xl mx-auto">
          {reasons.map((reason, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-6 md:p-8 mb-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col md:flex-row items-start md:items-center gap-6 group"
            >
              <div className="w-16 h-16 rounded-full bg-brand-red/10 flex items-center justify-center flex-shrink-0 group-hover:bg-brand-red transition-colors duration-300">
                <reason.icon className="text-brand-red text-2xl group-hover:text-white transition-colors" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-brand-black mb-2">{reason.title}</h3>
                <p className="text-gray-600 leading-relaxed">{reason.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhyUs;